import React from 'react';
import { SearchIcon } from '@/components/ui/Icons';
import { OverlayScrollArea } from '@/components/ui/OverlayScrollArea/OverlayScrollArea';
import '@/components/Messenger/styles/ChatSidebar.css';
import '@/components/Messenger/shared/messengerContactPicker.css';

export type MessengerContactPickerPanelProps = {
  sectionLabel: string;
  query: string;
  onQueryChange: (value: string) => void;
  searchDisabled?: boolean;
  searchPlaceholder?: string;
  searchId?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
};

/**
 * Панель списка контактов внутри модалки: подпись секции, поиск, прокрутка в рамке.
 */
export function MessengerContactPickerPanel({
  sectionLabel,
  query,
  onQueryChange,
  searchDisabled = false,
  searchPlaceholder = 'Поиск по имени и должности',
  searchId,
  children,
  footer,
}: MessengerContactPickerPanelProps) {
  return (
    <>
      <div className="messengerContactPicker__list">
        <div className="messengerContactPicker__listHead">
          <div className="messengerContactPicker__sectionLabel">{sectionLabel}</div>
          <div className="chatSidebar__searchRow messengerContactPicker__search">
            <SearchIcon size={14} className="chatSidebar__searchIcon" aria-hidden />
            <input
              id={searchId}
              type="search"
              value={query}
              onChange={(e) => onQueryChange(e.target.value)}
              placeholder={searchPlaceholder}
              className="chatSidebar__searchInput"
              disabled={searchDisabled}
              autoComplete="off"
            />
            {query ? (
              <button
                type="button"
                className="chatSidebar__searchClear"
                onClick={() => onQueryChange('')}
                aria-label="Очистить поиск"
              >
                ×
              </button>
            ) : null}
          </div>
        </div>
        <OverlayScrollArea className="messengerContactPicker__listScroll" defer={false}>
          <div className="messengerContactPicker__listInner">{children}</div>
        </OverlayScrollArea>
      </div>
      {footer}
    </>
  );
}
